/*
 * Compliant Commerce — retroactive link injection
 *
 * The Compliant Commerce product/collection availability blocks only accept
 * plain text for `notice_text`, so the "shop it at Medical Monks" call to
 * action renders unlinked. This walks the DOM, finds that phrase, and wraps
 * the store name in an anchor. It re-runs on DOM changes because the app
 * re-renders its notice whenever the visitor changes their state.
 */
(function () {
  'use strict';

  // Each rule: `phrase` scopes the match (must appear in the notice),
  // `anchorText` is the part of that phrase turned into a link.
  var RULES = [
    {
      phrase: 'shop it at Medical Monks',
      anchorText: 'Medical Monks',
      href: 'https://medicalmonks.com/',
      newTab: true,
    },
  ];

  var LINK_CLASS = 'compliant-commerce-alt-link';
  var SKIP_TAGS = { A: 1, SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, OPTION: 1, SELECT: 1 };

  function buildLink(rule) {
    var link = document.createElement('a');
    link.href = rule.href;
    link.className = LINK_CLASS;
    link.textContent = rule.anchorText;
    link.style.color = 'inherit';
    link.style.textDecoration = 'underline';
    if (rule.newTab) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }
    return link;
  }

  function isSkippable(node) {
    for (var el = node.parentElement; el; el = el.parentElement) {
      if (SKIP_TAGS[el.tagName]) return true;
    }
    return false;
  }

  // Splits a text node so that the store name inside `phrase` becomes a link.
  function linkifyTextNode(node, rule) {
    var text = node.nodeValue;
    var phraseAt = text.indexOf(rule.phrase);
    if (phraseAt === -1) return false;

    var anchorAt = text.indexOf(rule.anchorText, phraseAt);
    if (anchorAt === -1) return false;

    var tail = node.splitText(anchorAt);
    tail.nodeValue = tail.nodeValue.slice(rule.anchorText.length);
    node.parentNode.insertBefore(buildLink(rule), tail);
    return true;
  }

  // Fallback for when the app renders the phrase across nested inline markup.
  function linkifyElement(el, rule) {
    if (el.querySelector('a')) return false;
    if (el.innerHTML.indexOf(rule.phrase) === -1) return false;

    var replacement = rule.phrase.replace(
      rule.anchorText,
      buildLink(rule).outerHTML
    );
    el.innerHTML = el.innerHTML.replace(rule.phrase, replacement);
    return true;
  }

  function applyRule(rule) {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.nodeValue.indexOf(rule.phrase) === -1) return NodeFilter.FILTER_REJECT;
        if (isSkippable(node)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    var targets = [];
    var current;
    while ((current = walker.nextNode())) targets.push(current);

    if (targets.length) {
      targets.forEach(function (node) {
        linkifyTextNode(node, rule);
      });
      return;
    }

    // No single text node held the whole phrase — try the smallest elements
    // whose combined markup does.
    var candidates = document.querySelectorAll('p, span, div, li, small, strong, em');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.textContent.indexOf(rule.phrase) === -1) continue;
      var deeper = Array.prototype.some.call(el.querySelectorAll('*'), function (child) {
        return child.textContent.indexOf(rule.phrase) !== -1;
      });
      if (deeper) continue; // a descendant is a tighter match; let the loop reach it
      linkifyElement(el, rule);
    }
  }

  var scheduled = false;
  function run() {
    scheduled = false;
    RULES.forEach(applyRule);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(run);
  }

  function init() {
    run();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
